module.exports = __webpack_public_path__ + "media/images/vidguki-1-5f2b10f6d905dbb15b5b11bee382ed12.png";